import { View, Text } from "react-native";
import React from "react";

const User = () => {
  return (
    <View>
      <Text>User</Text>
    </View>
  );
};

export default User;
